import { IDS } from "@/constants/testIds";

export default function Chip({ label, active, onClick, testId, small = false }) {
  return (
    <button
      onClick={onClick}
      data-testid={testId}
      className={`flex-shrink-0 rounded-full border font-[Manrope] font-medium transition-colors active:scale-[0.97] ${
        small ? "px-4 py-1.5 text-xs" : "px-5 py-2 text-sm"
      } ${
        active
          ? "bg-[#6B7A54] text-white border-transparent shadow-[0_8px_24px_rgba(107, 122, 84,0.18)]"
          : "bg-white text-stone-700 border-stone-200 hover:bg-stone-50"
      }`}
    >
      {label}
    </button>
  );
}
export { IDS };
